// src/components/AuthInitializer.js
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  selectIsAuthenticated,
  selectAccessToken,
  logout,
} from "../store/auth-slice";
import { initAuthFromStorage, cleanupAutoRefresh } from "../utils/token";

const AuthInitializer = () => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const accessToken = useSelector(selectAccessToken);
  const dispatch = useDispatch();

  // Initialize auth state on first load
  useEffect(() => {
    initAuthFromStorage();

    // Listen for storage events to sync logout across tabs
    const handleStorageChange = (event) => {
      if (event.key === "accessToken" && !event.newValue && event.oldValue) {
        console.log(" logging out in auth initializer");
        // Token was removed in another tab, log out in this tab too
        dispatch(logout());
      }
    };

    window.addEventListener("storage", handleStorageChange);

    // Clean up on unmount
    return () => {
      window.removeEventListener("storage", handleStorageChange);
      cleanupAutoRefresh();
    };
  }, [dispatch]);

  return null; // This component doesn't render anything
};

export default AuthInitializer;
